"use client"

import useOrientation from "@/hooks/useOrientation"
import { motion } from "framer-motion"
import Topnav from "@/components/topnav"

export default function IframeScroll() {
  const { isPortrait, isLandscape, isStandalone } = useOrientation()

  return (
    <div className="
      relative w-full h-[100dvh]
      overflow-hidden overscroll-none
      touch-pan-y">

    <Topnav />

    <section 
      className={`
        w-full overflow-hidden select-none
        inset-0 flex flex-col overflow-hidden
        w-full
        select-none
        overscroll-none
        ${isPortrait ? "mb-0" : "" }
        ${isLandscape ? "bg-[var(--movil-nav)] h-[calc(100%-3.7rem)] border border-white/15 rounded-xl" : ""}
        ${isStandalone ? "overscroll-none mb-20" : "" }
      `}
      >
      
      {/* TOP NAV */}
      {/* <div className="absolute top-0 left-0 w-full z-50">
        <Topnav />
      </div> */}

      {/* MAIN WRAPPER */}
      <div className="w-full h-full pt-16 overflow-hidden">
        
        <motion.div
          className="w-full h-[calc(100%-0rem)] overflow-hidden rounded-2xl"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 2.5,
            ease: "easeInOut",
          }}
        >
          <iframe
            src="frames/scroll/index.html"
            title="Scrolling"
            className="w-full h-full border-0 overflow-hidden"
          />
        </motion.div>
      </div>

      {/* GLOBAL SCROLL LOCK (equivalente a tu CSS) */}
      <style>{`
        html, body {
          margin: 0;
          overflow: hidden;
          overscroll-behavior: contain;
          -webkit-user-select: none;
          user-select: none;
          -webkit-tap-highlight-color: transparent;
        }

        body::-webkit-scrollbar {
          width: 0px;
        }

        ::-webkit-scrollbar {
          width: 0px;
        }
      `}</style>
    </section>
    </div>
  )
}